import RugCardDetailedHeader from './RugCardDetailedHeader'
export default RugCardDetailedHeader
